import React from 'react';
import PropTypes from 'prop-types';
import {CloseButton} from '@learningblocks/storybook-components';
import style from './style.module.scss';

/**
 * TitleBar:
 *  - Component display the Titlebar for
 */
export function TitleBar(props) {
  return (
    <div className={style.titlebar}>
      <h4 className={style.titlebar_title}>{props.title}</h4>
      <CloseButton
        className={style.titlebar_close}
        close={props.close}
        size={props.closeButtonSize}
      />
    </div>
  );
}

TitleBar.propTypes = {
  /**
   * The title of the bar
   */
  title: PropTypes.string,
  /**
   * Function to invoke when close button is clicked
   */
  close: PropTypes.func,
};

TitleBar.defaultProps = {
  title: '',
  closeButtonSize: 'md',
};
